import React, { useEffect, useState } from 'react';
import Modal from 'apps/web_forms/components/commons/Modal';
import { modalMessages } from 'apps/web_forms/utils/constants';
import { showActionSuccessMessage } from 'apps/web_forms/slices/appSlice';
import { useDispatch } from 'react-redux';
import { template } from 'apps/web_forms/utils/strings';
import { isPublicForm as checkIsPublicForm } from 'apps/web_forms/api/api';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

const SuccessModal = () => {
  const dispatch = useDispatch();
  const { showingActionSuccessMessage, theSuccessfulAction } =
    useGlobalSelector();
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [isPublicForm, setIsPublicForm] = useState(false);

  useEffect(() => {
    setIsPublicForm(checkIsPublicForm());
  }, [isPublicForm, window.location.pathname]);

  useEffect(() => {
    if (showingActionSuccessMessage) {
      setSuccessModalOpen(true);
      dispatch(showActionSuccessMessage(false));
    }
  }, [showingActionSuccessMessage, dispatch]);

  const successMessageFormat = modalMessages.formActionSucess.main;
  const successMessage =
    theSuccessfulAction && theSuccessfulAction !== 'submitted'
      ? template(successMessageFormat, { action: theSuccessfulAction })
      : modalMessages.submitSuccess.main;

  return (
    <Modal
      mainMessage={successMessage}
      helpTip={modalMessages.submitSuccess.tip}
      isOpen={successModalOpen}
      setIsOpen={setSuccessModalOpen}
      icon='success'
      isFullScreen={isPublicForm}
      isFinal={isPublicForm}
    />
  );
};

export default SuccessModal;
